// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"6944bc80","456":"6f9ad0c2","787":"0dcaf384","899":"5fb68d65"}[chunkId] + ".chunk.js";
};